import createVueComponent from '../createVueComponent';
export default createVueComponent('bold', 'IconBold', [
  ['path', { d: 'M7 5h6a3.5 3.5 0 0 1 0 7h-6z', key: 'svg-0' }],
  ['path', { d: 'M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7', key: 'svg-1' }],
]);
